import { Link, useLocation } from 'react-router-dom';
import { Button } from './Button';

/**
 * Without this route an unknown URL rendered a blank white page with no header
 * and no way back.
 */
export function NotFound() {
  const location = useLocation();

  return (
    <div className="text-center py-16">
      <p className="font-mono text-sm text-gray-500 dark:text-gray-400">404</p>
      <h1 className="text-2xl font-bold tracking-tight mt-2">Nothing lives here</h1>
      <p className="text-gray-500 dark:text-gray-400 mt-2">
        <code className="font-mono text-sm break-all">{location.pathname}</code> isn't a page in PulseCheck.
      </p>
      <Link to="/" className="inline-block mt-6">
        <Button>Back to dashboard</Button>
      </Link>
    </div>
  );
}
